import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { appCheckCircleIcon } from './../../svg/check-circle';
import { appErrorCircleIcon } from './../../svg/error-circle';
import { LoadingModule } from './../loading/loading.module';
import { WizardButtonComponent } from './wizard-button/wizard-button.component';
import { WizardCompleteComponent } from './wizard-complete/wizard-complete.component';
import { WizardFailComponent } from './wizard-fail/wizard-fail.component';
import { WizardStepContentComponent } from './wizard-step-content/wizard-step-content.component';
import { WizardStepComponent } from './wizard-step/wizard-step.component';
import { WizardComponent } from './wizard.component';

@NgModule({
  declarations: [
    WizardComponent,
    WizardStepComponent,
    WizardStepContentComponent,
    WizardButtonComponent,
    WizardCompleteComponent,
    WizardFailComponent
  ],
  imports: [
    LoadingModule,
    CommonModule,
    SvgIconsModule.forChild([
      appCheckCircleIcon,
      appErrorCircleIcon
    ])
  ],
  exports: [
    WizardComponent,
    WizardStepComponent,
    WizardStepContentComponent,
    WizardButtonComponent,
    WizardCompleteComponent,
    WizardFailComponent
  ]
})
export class WizardModule { }
